import React, { useRef, useEffect } from "react";
import { message } from "antd";
import _ from "lodash";

import LoadingOverlay from "components/Indicator/LoadingOverlay";
import WithHOC from "./action";
import CoreRenderFunction from "DisplayCore";
import { LoginLayout } from "PageLayout/Login";
import { getItem, clearItem } from "utils/tokenStore";
import Axios from "axios";
import getDomainURL from "utils/api";

const Login = (props) => {
  let { data, profile, siteInfo, onLoadLogin, loginRequest, setUserProfile } =
    props;

  useEffect(() => {
    if (getItem("TECHBASE_TOKEN")) {
      return props.history.push("/dashboard");
    } else {
      clearItem("IMPERSONATE_TOKEN");
      if (!_.isEmpty(profile)) {
        setUserProfile({});
      }
      const onStorage = (e) => {
        if (e.key === "FORCE_LOGOUT") {
          console.warn("Received FORCE_LOGOUT broadcast — clearing tokens.");
          try {
            clearItem("TECHBASE_TOKEN");
            sessionStorage.removeItem("TECHBASE_TOKEN");
          } catch {}
          window.location.href = "#/login";
        }
      };

      window.addEventListener("storage", onStorage);
      return () => window.removeEventListener("storage", onStorage);
    }
  });

  let captchaRef = useRef();

  const onSubmitForm = (e) => {
    if (captchaRef.current.validateCaptcha(e.captcha)) {
      loginRequest({
        username: e.username,
        password: e.password,
        siteDomain: data.ClientReducer.siteInfo.domain,
      });
    } else {
      message.error("Invalid Captcha");
    }
  };

  const hideComponent = (actionKey) => {
    switch (actionKey) {
      case "isNotLoginByUsername":
        return siteInfo.login_by !== "username";
      case "isNotLoginByMobileNumber":
        return siteInfo.login_by !== "mobile_number";
      case "isNotLoginByLoginId":
        return siteInfo.login_by !== "login_id";
      default:
    }
  };
  function openMsalPopup(authUrl) {
    return new Promise((resolve, reject) => {
      const popup = window.open(authUrl, "msalPopup", "width=600,height=700");
      if (!popup) return reject(new Error("Popup blocked"));
      window.addEventListener("message", (event) => {
        if (event.data.type === "MSAL_LOGIN_SUCCESS") {
          if (event.data.status && event.data.status === "success") {
            loginRequest(event.data);
          } else {
            alert("MSAL Login failed. Please try again.");
          }
        }
      });
    });
  }

  const onClickAction = (actionKey) => {
    switch (actionKey) {
      case "MSALLOGIN":
        Axios.get(`${getDomainURL()}/auth/client_user/MSALlogin`)
          .then(async (response) => {
            const { authUrl } = response.data;
            if (!authUrl) throw new Error("No authUrl from backend");
            const token = await openMsalPopup(authUrl);
          })
          .catch((error) => {
            console.error("MSAL login failed:", error);
          });
        break;
      default:
        return;
    }
  };
  return (
    <>
      <CoreRenderFunction
        {...props}
        item={LoginLayout}
        hideComponent={hideComponent}
        onClickAction={onClickAction}
        captchaRef={captchaRef}
      />
      {onLoadLogin && <LoadingOverlay />}
    </>
  );
};

export default WithHOC(Login);
